/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSEOBody
 */
export interface CreateSEOBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSEOBody
     */
    url: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSEOBody
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the CreateSEOBody interface.
 */
export function instanceOfCreateSEOBody(value: object): value is CreateSEOBody {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function CreateSEOBodyFromJSON(json: any): CreateSEOBody {
    return CreateSEOBodyFromJSONTyped(json, false);
}

export function CreateSEOBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSEOBody {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'tags': json['tags'],
    };
}

export function CreateSEOBodyToJSON(json: any): CreateSEOBody {
    return CreateSEOBodyToJSONTyped(json, false);
}

export function CreateSEOBodyToJSONTyped(value?: CreateSEOBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'tags': value['tags'],
    };
}

